import { useParams, useNavigate } from 'react-router-dom';
import { useVendorAccess } from '@/hooks/useVendorAccess';
import { useAuth } from '@/contexts/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { getProductById } from '@/data/vendorDashboard';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { ChangeRequestForm } from '@/components/vendor/ChangeRequestForm';
import { useEffect } from 'react';
import { toast } from 'sonner';

export default function VendorChangeRequest() {
  useVendorAccess();
  const { productId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();

  const { data: product, isLoading } = useQuery({
    queryKey: ['product', productId],
    queryFn: () => getProductById(productId!),
    enabled: !!productId,
  });

  // Verify ownership
  useEffect(() => {
    if (product && product.vendor_email !== user?.email) {
      toast.error('You do not have permission to request changes for this product');
      navigate('/vendor');
    }
  }, [product, user, navigate]);

  if (isLoading || !product) {
    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1 container py-8">
          <div>Loading...</div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container py-8">
        <Button
          variant="ghost"
          onClick={() => navigate('/vendor')}
          className="mb-6"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Dashboard
        </Button>

        <div className="max-w-3xl mx-auto">
          <ChangeRequestForm
            productId={product.id}
            productTitle={product.title}
            onSuccess={() => navigate('/vendor')}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}
